module.exports = (__webpack_require__(351725))("./node_modules/mobx/dist/mobx.esm.js");